import { Api, Auth } from '~/services'


export function postViewHistory( postType, postSlug ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !postType || !postSlug ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_VIEW_HISTORY'
				})

				Api.post( '/wp/history/' + postType + '/' + postSlug, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_NEW_VIEW_HISTORY',
						history: data
					})
				})

			}
		)
	}
}


export function updateViewHistory( postType, postSlug, progress ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !postType || !postSlug ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_VIEW_HISTORY'
				})

				Api.put( '/wp/history/' + postType + '/' + postSlug + '/' + progress, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_UPDATED_VIEW_HISTORY',
						history: data
					})
				})

			}
		)
	}
}


export function getUserViewHistory( query ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_VIEW_HISTORY'
				})

				Api.get( '/wp/history', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_VIEW_HISTORY',
						history: data
					})
				})

			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/actions/viewhistory.js